import React from 'react';
import Layout from '../../components/Layout/Layout';
import GuestReview from './GuestReview';

// Open route (no auth): the logged-out guest reviews the request they built, sees the real price,
// and fills description / schedule / matching preference. Account + card + booking happen only on
// the final CTA. A logged-in user keeps using the existing /order flow, not this screen.
async function action({ store }) {
    const title = store.getState().siteSettings?.data?.siteTitle;
    const description = store.getState().siteSettings?.data?.metaDescription;
    return {
        title,
        description,
        component: (
            <Layout>
                <div className={'withoutPageMainContainer'}>
                    <GuestReview />
                </div>
            </Layout>
        ),
    };
}

export default action;
